import {ChatBase} from "@core/base/chat-base";
import {Observable} from "rxjs";
import {IChatMessage, IChatMessageResult} from "@listat/r2-core";
import {IChatActionsData} from "@core/base/chat-action-base";
import {OfficeChatAdapterServiceV1} from "@core/office/office-chat/office-chat-v1";
import {OfficeChatBase} from "@core/office/office-chat/office-chat-base";
import { OfficeChatRepository } from "@core/office/office-chat-repository/office-chat-repository";
import { OfficeChatSetting } from "@core/office/office-chat-setting/office-chat-setting";
import { ICoreDependencies } from "@core/core-boot/core-boot.types";
import { OfficeSessionService } from "@core/office/office-session/office.session.service";
import { ChatUtilsService } from "@core/shared/chat-utils.service";
import { OfficeService } from "@core/office/office-service/office-service";

export class OfficeChat extends ChatBase implements ChatBase {
    private officeChat: OfficeChatBase = new OfficeChatAdapterServiceV1(
        this.dependencies,
        this.office,
        this.chatRepository,
        this.chatUtils,
        this.settingService,
        this.sessionService,
    );

    constructor(
        private dependencies: ICoreDependencies,
        private office: OfficeService,
        private chatRepository: OfficeChatRepository,
        private chatUtils: ChatUtilsService,
        private settingService: OfficeChatSetting,
        private sessionService: OfficeSessionService,
    ) {
        super()
    }

    public $isMessagesLoading(): Observable<boolean> {
        return this.officeChat.$isMessagesLoading();
    }

    public clearMessages(): Promise<void> {
        return this.officeChat.clearMessages();
    }

    public getMessages(): Observable<IChatMessage[]> {
        return this.officeChat.getMessages();
    }

    public getMessagesValue(): IChatMessage[] {
        return this.officeChat.getMessagesValue();
    }

    public override onDestroy(): void {
        this.officeChat.onDestroy();
    }

    public sendMessage(data: string, dataAction: IChatActionsData | null): Promise<IChatMessageResult> {
        return this.officeChat.sendMessage(data, dataAction);
    }

    public sendMessageWithoutSaving(data: string, dataAction: IChatActionsData | null): Promise<IChatMessageResult> {
        return this.officeChat.sendMessageWithoutSaving(data, dataAction);
    }

    public writeBotMessage(text: string): Promise<void> {
        return this.officeChat.writeBotMessage(text);
    }

}
